<template>
    <div>
        <div class="w-layout-grid filters-grid">
            <div class="justify-self-stretch">
                <input  @input="searchTeachers()" class="form-control search" id="search" type="search" v-model="search.filterSearch" value="" :placeholder="trans('forms.search')" aria-label="Search by filename">
            </div>
            <div class="flex inline">
                <label class="field-label small mr">{{trans('course.coauthors_sort_by')}}</label>
                <select @change="getTeachers()"  v-model="search.filterName" class="form-control" id="name" name="name">
                    <option value="">{{trans('course.coauthors_select_option')}}</option>
                    <option value="asc">{{trans('course.coauthors_ascending')}} </option>
                    <option value="desc">{{trans('course.coauthors_descending')}}</option>
                </select>
            </div>
            <div class="flex sort">
                <select for="entries" @change="getTeachers()" v-model="search.entries" class="form-control sort" id="entries" name="entries">
                    <option value="6">6</option>
                    <option value="12">12</option>
                    <option value="24">24</option>
                    <option value="48">48</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-4" v-for="teacher in teachers">
                <div class="form-check">
                  <input @change="checkCoauthor()" v-model="form.coauthors" class="form-check-input" type="checkbox" :value="teacher.id" :id="'coauthor-'+teacher.id">
                  <label class="form-check-label" :for="'coauthor-'+teacher.id">
                    {{teacher.first_name}} {{teacher.last_name}}
                  </label>
                </div>
            </div>
             <div class="col-12 text-center mt-3" >

                <button v-if="showLoadMore" type="button" @click='getTeachers(search.page)' class="btn btn-primary">{{trans('course.coauthors_load_more')}}</button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "coauthors",
        components: {
        },
        created() {
            this.getTeachers();
            this.getCoauthors();
        },
        props: {
            cid: Number,
        },
        data: function() {
            return {
                teachers: [],
                showLoadMore: true,
                search: {
                    filterName : '',
                    filterSearch: '',
                    page: 1,
                    entries: 24,
                },
                form: {
                    cid: this.cid,
                    coauthors: [],
                }
            }
        },
        mounted(){
        },
        methods: {
            searchTeachers : function () {
                if (this.teachers.length < 1000 && (this.search.filterSearch.length >= 2 || this.search.filterSearch.length === 0)) {
                    this.getTeachers()
                }
            },
            getTeachers: function(page=false) {
                let $end = '/api/get-teachers/';
                let self = this;

                if (page) {
                    this.search.page =  this.search.page+1;
                } else {
                    this.search.page = 1;
                    self.showLoadMore =  true;
                }

                axios.get($end, {params: this.search}).then(function (response) {
                    response = response.data;
                    if ( self.search.page == response.meta.last_page) {
                        self.showLoadMore =  false;
                    }

                    if (page) {
                        self.teachers = [...self.teachers, ...response.data];
                    } else {
                        self.teachers = response.data;
                    }
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            },
            getCoauthors: function() {
                let $end = '/api/get-coauthors/'+this.form.cid;
                let self = this;
                axios.get($end).then(function (response) {
                    response = response.data;
                    self.form.coauthors = response;

                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            },
            checkCoauthor: function() {
                let $end = '/api/save-coauthors';
                let self = this;

                axios.post($end, this.form).then(response  => {
                    self.loader = false;
                }).catch(err => {
                    self.$data.loader = false;
                });

            },
        },

    }
</script>
